import React, { useEffect, useState } from 'react'
import { resolveMediaUrl } from '../../utils/Network'

function isDirectVideoUrl(url) {
    if (!url) return false
    const u = String(url)
    const lower = u.toLowerCase()
    return (
        lower.includes('firebasestorage') ||
        lower.includes('/api/uploaded_media/') ||
        lower.includes('.run.app') ||
        lower.includes('storage.googleapis.com') ||
        lower.includes('s3.amazonaws.com') ||
        /\.(mp4|webm|mov|m4v)(\?|$)/i.test(u)
    )
}

export default function UrlEmbed({ url,...props }) {

    useEffect(() => {

    }, [])

    const urlSource = () => {
        if (!url) return;
        if (url.includes("instagram.com")) return 'instagram'
        if (url.includes("youtube.com") || url.includes("youtu.be") ) return 'youtube'
        if (url.includes("tiktok.com")) return 'tiktok'
        if (isDirectVideoUrl(url)) return 'file'
        return "web"
    }

    function getId(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
    }


    return (
        <>
            {urlSource() === "instagram" &&
                <>
                    <a href={url} target="_blank" className="weburl" title="click to view content">
                        <h4 className="url-content">
                            <i className="fa fa-instagram fs-icon"></i>
                            <p className="mt-10"> Click to view instagram post</p>
                        </h4>
                    </a>
                </>
            }

            {urlSource() === "youtube" &&
                <>
                    <iframe width="100%" height="400" src={`//www.youtube.com/embed/${getId(url)}`} frameborder="0" allowfullscreen>

                    </iframe>
                </>
            }

            {urlSource() === "file" &&
                <>
                    <video controls height={props.height ? props.height : 320} width="100%" src={resolveMediaUrl(url) || url}></video>
                </>
            }

            {urlSource() === "web" &&
                <>
                    <a href={url} target="_blank" className="weburl" title="click to view content">

                        <h4 className="url-content">
                            <i className="fa fa-play"></i>
                            <p> Click to visit url</p>
                        </h4>
                    </a>
                </>
            }

            {urlSource() === "tiktok" &&
                <>
                    <a href={url} target="_blank" className="weburl" title="click to view content">
                        <h4 className="url-content">
                            <i className="fab fa-tiktok"></i>
                            <p> Click to visit Tiktok post</p>
                        </h4>
                    </a>
                </>
            }
        </>
    )
}
